module.exports = __webpack_public_path__ + "static/51966a549fcf7a37404d9f7fa1846ede8bc2027d82b4a96df02ec96c867d9e75-56594cc35d344af8a8614cb7d28da730.jpeg";